import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
    selector: 'app-associated-plans-table',
    templateUrl: './associated-plans-table.component.html',
    styleUrls: [
        './associated-plans-table.component.scss',
    ],
    standalone: false
})

export class AssociatedPlansTableComponent implements OnInit {
  @Input() carrierId: number;
  associatedPlans: [];
  selectedAssociatedPlan: any;
  first: number = 0;
  last: number;
  rows:number = 10;
  totalRecords: number;

  tableConfig = {
    columns: {
      name: {
        title: 'Plan name',
      },
      auth_required: {
        title: 'Auth Required?',
      },
      brokered_transport: {
        title: 'Brokered?',
      },
      updated_at: {
        title: 'Last Updated',
      }
    },
    actions: {
      add: false,
      edit: false,
      delete: false
    },
  };

  keys = Object.keys(this.tableConfig.columns);
  placeholders = {
    name: 'Plan name',
    auth_required: 'Auth Required?',
    brokered_transport: 'Brokered?',
    updated_at: 'Last Updated',
  };

  constructor(
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit() {
    const url = `/carriers/${this.carrierId}/plans`;
    this.http.get(`${environment.apiurl}/${url}`, { observe: 'response' }).subscribe((response: any) => {
      this.totalRecords = response.body.meta['x-total-count'];
      this.associatedPlans = this.formatPlansData(response.body.data);
    });
  }


  formatPlansData = (associatedPlans) => {
    associatedPlans.forEach((plan) => {
      plan['name'] = plan.plan_name;
      plan.updated_at = moment(plan.updated_at).format('LL');
      plan.auth_required = plan.auth_required ? 'Yes' : 'No';
      plan.brokered_transport = plan.brokered_transport ? 'Yes' : 'No';
    });
    return associatedPlans;
  }

  onRowSelect(event) {
    this.router.navigate(['/payer/active-plans', event.data.id]);
  }
}
